/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AppointmentNoteValue } from './AppointmentNoteValue';
import {
    AppointmentNoteValueFromJSON,
    AppointmentNoteValueFromJSONTyped,
    AppointmentNoteValueToJSON,
} from './AppointmentNoteValue';

/**
 * 
 * @export
 * @interface AppointmentNoteHistory
 */
export interface AppointmentNoteHistory {
    /**
     * 
     * @type {AppointmentNoteValue}
     * @memberof AppointmentNoteHistory
     */
    value: AppointmentNoteValue;
    /**
     * 
     * @type {string}
     * @memberof AppointmentNoteHistory
     */
    author_id?: string;
    /**
     * 
     * @type {string}
     * @memberof AppointmentNoteHistory
     */
    action: string;
}

/**
 * Check if a given object implements the AppointmentNoteHistory interface.
 */
export function instanceOfAppointmentNoteHistory(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "value" in value;
    isInstance = isInstance && "action" in value;

    return isInstance;
}

export function AppointmentNoteHistoryFromJSON(json: any): AppointmentNoteHistory {
    return AppointmentNoteHistoryFromJSONTyped(json, false);
}

export function AppointmentNoteHistoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): AppointmentNoteHistory {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'value': AppointmentNoteValueFromJSON(json['value']),
        'author_id': !exists(json, 'author_id') ? undefined : json['author_id'],
        'action': json['action'],
    };
}

export function AppointmentNoteHistoryToJSON(value?: AppointmentNoteHistory | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'value': AppointmentNoteValueToJSON(value.value),
        'author_id': value.author_id,
        'action': value.action,
    };
}

